/** Пути API. Единственное место, где они записаны строками. */
export const API = {
  /* ---- реальные эндпоинты Kepler Vision AZS API ---- */
  columns: '/api/v1/columns',
  cashiers: '/api/v1/cashiers',
  queues: {
    /** Очередь на кассах сейчас (ТЗ п. 5.1), период не учитывает. */
    current: '/api/v1/queues',
    /** Средняя очередь и ряд за период (ТЗ п. 5.2, 5.4). */
    history: '/api/v1/queues/history',
  },
  /** Входы посетителей за период бакетами (ТЗ п. 5.3, 5.5). */
  visitors: '/api/v1/visitors',
  /* Тег Plates в Swagger (до 15.09.2026 пути назывались /vehicles/*). */
  plates: {
    summary: '/api/v1/plates/summary',
    top: '/api/v1/plates/top',
    visits: '/api/v1/plates/visits',
    /** Посещения за период бакетами для графика (ТЗ п. 6.3). */
    chart: '/api/v1/plates/chart',
    /** Кадр распознавания (JPEG с уже нарисованной рамкой). Без kind: у распознавания нет клипа. */
    frame: (id: string) => `/api/v1/plates/visits/${encodeURIComponent(id)}/frame`,
  },
  events: {
    list: '/api/v1/events',
    byId: (id: string) => `/api/v1/events/${encodeURIComponent(id)}`,
    media: (id: string, kind: 'image' | 'video') =>
      `/api/v1/events/${encodeURIComponent(id)}/media?kind=${kind}`,
  },

  /* ---- авторизации у бэкенда АЗС пока нет: контракт наш, работает только при VITE_AUTH_ENABLED ---- */
  auth: {
    login: '/api/v1/auth/login',
    refresh: '/api/v1/auth/refresh',
    logout: '/api/v1/auth/logout',
    me: '/api/v1/auth/me',
  },
} as const
